import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import * as moment from 'moment';
import { MatDatepicker } from '@angular/material/datepicker';
import { CalendarHeaderComponent } from 'src/app/shared/components/calendar-header/calendar-header.component';


@Component({
    selector: 'app-payapp-date-filter',
    templateUrl: './payapp-date-filter.component.html',
    styleUrls: ['../styles.scss', './payapp-date-filter.component.scss'],
    standalone: false
})
export class PayappDateFilterComponent {
  // Shared Figma-styled calendar header (chevrons + white-chip tooltip).
  public calendarHeader = CalendarHeaderComponent;
  @Output() dateChanged = new EventEmitter<{ startDate: string | null, endDate: string | null }>();
  @ViewChild('picker') picker: MatDatepicker<any>;
  form: FormGroup;

  ngAfterViewInit() {
    this.picker.openedStream.subscribe(() => {
      // Add the custom class to the overlay pane when the datepicker opens
      const overlayElement = document.querySelector('.cdk-overlay-pane');
      if (overlayElement) {
        overlayElement.classList.add('payapp-datepicker-overlay');
      }
    });
  }


  constructor(private fb: FormBuilder) {
    this.form = this.fb.group({
      startDate: [null],
      endDate: [null],
    });

    this.form.valueChanges.subscribe(() => {
      this.emitDateChange();
    });
  }


  emitDateChange(): void {
    // Use startOf('day') to ensure we get the correct date regardless of timezone
    const startDate = this.form.controls.startDate.value
      ? moment(this.form.controls.startDate.value).startOf('day').format('YYYY-MM-DD')
      : null;
    const endDate = this.form.controls.endDate.value
      ? moment(this.form.controls.endDate.value).startOf('day').format('YYYY-MM-DD')
      : null;
    this.dateChanged.emit({ startDate, endDate });
  }

  removeDateFilter(event: Event): void {
    event?.stopPropagation();
    this.form.reset();
    this.emitDateChange();
  }
}
